import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: inline-block;\n  right: 0px;\n  top: 0px;\n  cursor: pointer;\n  padding: 24px;\n  line-height: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  position: relative;\n  padding: ", ";\n  outline: none;\n  width: ", ";\n  min-height: ", ";\n\n  background: #ffffff;\n  box-shadow: ", ";\n  border-radius: 4px;\n\n  @media (max-width: 700px) {\n    flex: 1 1 auto;\n    margin: 10px;\n    align-self: start;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(75, 75, 75, 0.7);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useRef, useState } from 'react'; // import 'inert-polyfill'

import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { useDynamicBodyEl, useFocus, getUniqueId, useInertOther, KEYCODES } from '../../shared';
import ModalContext from '../data/ModalContext';
import Icon from '../../icon';
import { faTimes } from '../../icon/sets/regular';
var Overlay = styled.div(_templateObject());
var Dialog = styled(function (props) {
  var ref = useRef();
  useInertOther(ref);
  useFocus(ref, {
    shouldFocus: true,
    returnFocusOnLeave: true
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: ref
  }));
})(_templateObject2(), function (_ref) {
  var wrapLeftOfCloseButton = _ref.wrapLeftOfCloseButton;
  return wrapLeftOfCloseButton ? '24px 54px 24px 24px' : '24px';
}, function (_ref2) {
  var size = _ref2.size;
  return {
    small: '400px',
    medium: '504px',
    large: '720px'
  }[size];
}, function (_ref3) {
  var size = _ref3.size;
  return {
    small: '224px',
    medium: '224px',
    large: '400px'
  }[size];
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.shadowLargest.split(',').slice(0, -1).join(','), ", 0.5)");
});
var DefaultCloseButton = styled(function (props) {
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(Icon, {
    icon: faTimes
  }));
})(_templateObject3());

var Modal = function Modal(_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 'medium' : _ref5$size,
      _ref5$open = _ref5.open,
      open = _ref5$open === void 0 ? false : _ref5$open,
      _ref5$onClose = _ref5.onClose,
      onClose = _ref5$onClose === void 0 ? function () {} : _ref5$onClose,
      children = _ref5.children,
      CloseButton = _ref5.CloseButton,
      _ref5$showCloseButton = _ref5.showCloseButton,
      showCloseButton = _ref5$showCloseButton === void 0 ? false : _ref5$showCloseButton;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasTitle = _useState2[0],
      setHasTitle = _useState2[1];

  var id = useRef(getUniqueId()).current;
  var portalEl = useDynamicBodyEl();
  var CloseButtonComponent = CloseButton || DefaultCloseButton;

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === KEYCODES.ESC) {
      onClose();
    }
  };

  return open ? createPortal( /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: {
      close: onClose,
      id: id,
      registerTitle: function registerTitle() {
        return setHasTitle(true);
      }
    }
  }, /*#__PURE__*/React.createElement(Overlay, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Dialog, {
    wrapLeftOfCloseButton: showCloseButton && !hasTitle,
    tabIndex: 0,
    size: size,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onKeyDown: handleKeyDown,
    id: "dialog-".concat(id),
    role: "dialog",
    "aria-labelledby": "dialog-title-".concat(id),
    "aria-describedby": "dialog-contents-".concat(id),
    "aria-modal": true
  }, (showCloseButton || CloseButton) && /*#__PURE__*/React.createElement(CloseButtonComponent, {
    onClick: onClose
  }), children))), portalEl) : null;
};

export default Modal;